export default "__VITE_ASSET__e7fdd69c__"